import React from "react";

const Footer = () => {
  return (
    <div>
      <footer>Copyright &copy; 2022 Food Spot</footer>
    </div>
  );
};

export default Footer;
